// NPM Imports
import { pick } from "lodash";

// Internal Imports
import store from "../../store";

// eslint-disable-next-line import/prefer-default-export
export const parseRowData = (obj, flag) => {
  const { rowData, metaData } = store.getState().PricebookStore;
  const { rowId } = obj.RowRecords[0];
  const rowIndex = rowData.findIndex(field => field.id === rowId);
  const clonedRowData = [...rowData];
  // Replace the linkedRows values
  obj.RowRecords.forEach(record => {
    metaData.linkedTables.forEach(tbl => {
      const linkedRows = record.linkedRows.find(row => row.tblId === tbl.tblId);
      if (linkedRows) {
        linkedRows.rows.forEach(row => {
          // Merge colValue & linkedRecords value together
          record.colValues = {
            ...record.colValues,
            ...pick(row.colValues, tbl.ids), // Pick all the linkedRecord FLD id's from linkedRows
          };
        });
      }
    });
  });
  const fields = obj.RowRecords[0].colValues;
  fields.id = rowId;
  // On row update
  if (flag) {
    fields.index = clonedRowData[rowIndex].index; // Set existing row index to new value
    clonedRowData.splice(rowIndex, 1, obj.RowRecords[0].colValues);
    return clonedRowData;
  }
  // On row addition
  clonedRowData.unshift(fields);
  // Reset the index values of the rows
  clonedRowData.forEach((row, index) => {
    delete row.index;
    row.index = index;
  });
  return clonedRowData;
};
